module.exports = __webpack_public_path__ + "static/media/editWeekBlock.bce3f302.svg";